const TeceoShortLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.1 62.48">
    <defs>
      <style>{'.cls-1{fill:#97999b;}.cls-2{fill:#ff703d;}'}</style>
    </defs>
    <g id="Camada_2" data-name="Camada 2">
      <g id="Camada_1-2" data-name="Camada 1">
        <g id="Camada_2-2" data-name="Camada 2">
          <g id="Camada_1-2-2" data-name="Camada 1-2">
            <path
              className="cls-1"
              d="M39.63,0h-.41A31.24,31.24,0,0,0,8.39,31.21a32.21,32.21,0,0,0,.34,4.7,31.12,31.12,0,0,0,30,26.57h.38A31,31,0,0,0,67,44.63a5.78,5.78,0,0,0-.34-5.57,5.57,5.57,0,0,0-4.71-2.6h0a5.62,5.62,0,0,0-5.1,3.29,19.46,19.46,0,0,1-36.61-3.66,19.87,19.87,0,0,1,19-24.71h.24A19.68,19.68,0,0,1,56.87,22.76a5.64,5.64,0,0,0,5,3.3h.07a5.55,5.55,0,0,0,4.72-2.6A5.74,5.74,0,0,0,67,17.9,30.93,30.93,0,0,0,39.63,0Z"
            />
            <path
              className="cls-2"
              d="M38.9,26.32H5.11a4.89,4.89,0,0,0-.44,9.77H38.9a4.89,4.89,0,1,0,.44-9.77A3.23,3.23,0,0,0,38.9,26.32Z"
            />
            <path
              className="cls-2"
              d="M82,26.32H77.16a4.89,4.89,0,0,0,0,9.77H82a4.89,4.89,0,1,0,.44-9.77A3.23,3.23,0,0,0,82,26.32Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default TeceoShortLogo;
